import env from "./../env";

const Config = {
  apiUrl: env.baseUrl+'/api',
  apiBoUrl: env.baseUrl+'/api/public/bo-api',
}

export default Config